<template>
  <div>
    <div class="review-showcase-title">
      <div
        class="review-showcase-title__image review-showcase-title__image--left"
      ></div>
      <div class="flex flex-col items-center">
        <div class="text-5xl font-bold text-teal-900">
          {{ averageRating?.toString().replace(',', '.') }}
        </div>
        <div>
          <div class="flex flex-row items-center justify-center gap-2">
            <ReviewRatingStars
              class="justify-center"
              star-classes="h-6"
              :average-rating="
                parseFloat(averageRating?.toString().replace(',', '.'))
              "
            />
            <Tooltip
              v-if="reviewType === 'partner'"
              :tooltip-text="t('review.partnerRating.tooltip')"
              length="large"
              position="down"
              type="span"
            >
              <span class="text-xs text-gray-600">
                {{ t('review.partnerRating.label') }}
              </span>
            </Tooltip>
          </div>
        </div>
      </div>

      <div
        class="review-showcase-title__image review-showcase-title__image--right"
      ></div>
    </div>

    <div class="text-xs text-gray-600 text-center">
      {{ t('product.reviews.reviewSectionSubtitle', reviewCount) }}
    </div>
  </div>
</template>
<script setup lang="ts">
const { t } = useI18n()

const { averageRating } = defineProps({
  averageRating: {
    type: String,
    default: '',
  },
  reviewCount: {
    type: Number,
    default: 0,
  },
  supplierName: {
    type: String,
    default: '',
  },
  reviews: {
    type: Array,
    default: () => [],
  },
  supplierCreatedAt: {
    type: String,
    default: '',
  },
  reviewType: {
    type: String,
    default: 'event',
  },
})
</script>

<style lang="postcss" scoped>
.review-showcase-title {
  position: relative;
  @apply flex justify-center items-center gap-2;

  &__image {
    width: 34px;
    height: 90px;
    background: url('/_nuxt3-static/reviews/review-confetti.svg') no-repeat
      center;
    background-size: cover;
    transform: scale(0.7);

    &--right {
      transform: rotate(200deg) scale(0.7);
    }
  }

  @media (prefers-reduced-motion: no-preference) {
    &:hover .review-showcase-title__image--left {
      animation: confetti-wiggle-left 1.6s ease-in-out infinite;
    }

    &:hover .review-showcase-title__image--right {
      animation: confetti-wiggle-right 1.6s ease-in-out infinite;
    }
  }
}

@keyframes confetti-wiggle-left {
  0%,
  100% {
    transform: translate(0, 0) rotate(0deg) scale(0.7);
  }
  25% {
    transform: translate(-2px, -5px) rotate(-8deg) scale(0.74);
  }
  75% {
    transform: translate(1px, -2px) rotate(4deg) scale(0.72);
  }
}

@keyframes confetti-wiggle-right {
  0%,
  100% {
    transform: translate(0, 0) rotate(200deg) scale(0.7);
  }
  25% {
    transform: translate(2px, -5px) rotate(208deg) scale(0.74);
  }
  75% {
    transform: translate(-1px, -2px) rotate(196deg) scale(0.72);
  }
}
</style>
